var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNodataicon = function SvgNodataicon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3916_23718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1305 12.5057L10.8609 10.2361C11.71 9.24492 12.2227 7.95703 12.2227 6.54883C12.2227 3.41523 9.68242 0.875 6.54883 0.875C3.41523 0.875 0.875 3.41523 0.875 6.54883C0.875 9.68242 3.41523 12.2227 6.54883 12.2227C7.95977 12.2227 9.25039 11.7072 10.243 10.8555L12.5125 13.125L13.1305 12.5057ZM6.54883 11.3477C5.90078 11.3477 5.27188 11.2205 4.68125 10.9703C4.10977 10.7283 3.59707 10.3824 3.15547 9.94219C2.71387 9.50195 2.36797 8.98789 2.12734 8.41641C1.87715 7.82578 1.75 7.19688 1.75 6.54883C1.75 5.90078 1.87715 5.27187 2.12734 4.68125C2.36934 4.10977 2.71523 3.59707 3.15547 3.15547C3.5957 2.71387 4.10977 2.36797 4.68125 2.12734C5.27188 1.87715 5.90078 1.75 6.54883 1.75C7.19688 1.75 7.82578 1.87715 8.41641 2.12734C8.98789 2.36934 9.50059 2.71523 9.94219 3.15547C10.3838 3.5957 10.7297 4.10977 10.9703 4.68125C11.2205 5.27187 11.3477 5.90078 11.3477 6.54883C11.3477 7.19688 11.2205 7.82578 10.9703 8.41641C10.7283 8.98789 10.3824 9.50059 9.94219 9.94219C9.50195 10.3838 8.98789 10.7297 8.41641 10.9703C7.82578 11.2205 7.19688 11.3477 6.54883 11.3477Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27188 9.57305C4.88086 9.40762 4.53086 9.17109 4.22871 8.86895C3.92656 8.5668 3.69004 8.2168 3.52461 7.82578C3.35371 7.42109 3.26758 6.9918 3.26758 6.54883H2.7207C2.7207 8.6625 4.43516 10.377 6.54883 10.377V9.83008C6.10586 9.83008 5.67656 9.74395 5.27188 9.57305Z",
    fill: "#BFBFBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3916_23718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNodataicon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nodataicon.fb8a3b88.svg";
export { ForwardRef as ReactComponent };